import {AfterViewInit, Component, ElementRef, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppContainerService, AppRightDrawerService, SideNavBarService} from '@mydocma/app-container';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {combineLatest} from 'rxjs';
import {TaskDashboardComponent, TaskViewService} from '@mydocma/task';
import {MmTaskDashboardService} from './mm-task-dashboard.service';
import {PlatformModeStateService} from '../../../mm-offline/services/platform-mode-state.service';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-task-dashboard',
  templateUrl: './mm-task-dashboard.component.html',
  styleUrls: ['./mm-task-dashboard.component.scss']
})
export class MmTaskDashboardComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('daskboard', {static: false})  taskDashboardComponent: TaskDashboardComponent;

  @HostBinding('class.is-ios') get isIos(): boolean {
    return this.platformModeStateService.isIos;
  }

  constructor(private readonly appRightDrawerService: AppRightDrawerService,
              public appContainerService: AppContainerService,
              public readonly sideNavbarService: SideNavBarService,
              private readonly taskDashboardService: MmTaskDashboardService,
              private readonly platformModeStateService: PlatformModeStateService) {

    combineLatest([
      this.appContainerService.mobileView$,
      this.appRightDrawerService.isOpen
    ])
    .pipe(untilDestroyed(this))
    .subscribe(([isMobile, isOpen]) => {

      this.sideNavbarService.barVisibility = !(isMobile && isOpen);

    });
  }
  ngOnDestroy(): void {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.taskDashboardService.taskViewService = this.taskDashboardComponent.taskViewService;
  }

  onCloseClick() {
      this.appRightDrawerService.close();
  }
}
